import { useEffect } from 'react';
import { useApp } from '../state/store';

function typing(t: EventTarget | null): boolean {
  if (!(t instanceof HTMLElement)) return false;
  return (
    t.isContentEditable ||
    (['INPUT', 'TEXTAREA', 'SELECT'].includes(t.tagName) &&
      (t as HTMLInputElement).type !== 'range')
  );
}

/** Global shortcuts. They never steal keys from fields or dialogs. UI-015 */
export function useShortcuts(): void {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (typing(e.target)) return;
      const st = useApp.getState();
      if (document.querySelector('dialog[open]')) return;
      const media = document.querySelector<HTMLMediaElement>('.stage video, .stage audio');
      const key = e.key;

      if (key === 'Escape') {
        if (st.focus) st.setFocus(false);
        else if (st.queueOpen) st.setQueueOpen(false);
        return;
      }
      if (key === '?') return st.setPanel('help');
      if (key === 'q' || key === 'Q') return st.setQueueOpen(!st.queueOpen);
      if (!st.activeId) return;
      if (key === 'f' || key === 'F') {
        e.preventDefault();
        return st.setFocus(!st.focus);
      }
      if (!media) return;
      const onSlider =
        e.target instanceof HTMLElement && e.target.getAttribute('role') === 'slider';
      switch (key) {
        case ' ':
        case 'k':
        case 'K':
          if (e.target instanceof HTMLButtonElement) return; // let the button act
          e.preventDefault();
          if (media.paused) void media.play().catch(() => undefined);
          else media.pause();
          return;
        case 'ArrowLeft':
          if (onSlider) return;
          e.preventDefault();
          media.currentTime = Math.max(0, media.currentTime - 5);
          return;
        case 'ArrowRight':
          if (onSlider) return;
          e.preventDefault();
          media.currentTime = media.currentTime + 5;
          return;
        case 'j':
        case 'J':
          media.currentTime = Math.max(0, media.currentTime - 10);
          return;
        case 'l':
        case 'L':
          media.currentTime = media.currentTime + 10;
          return;
        case 'm':
        case 'M':
          media.muted = !media.muted;
          return;
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}
